import { Text } from '@mantine/core';
import { IPermit, useGetCountrySubdivisionsQuery } from '../../../api-client';

const PermitAddressFormat = ({ permit }: { permit?: IPermit }) => {
  const {
    data: { member: countrySubdivision },
  } = useGetCountrySubdivisionsQuery({
    vars: {
      'order[nameFr]': 'ASC',
      pagination: 'false',
    },
    options: {
      enabled: false,
    },
  });

  if (!permit || !countrySubdivision) return <div />;

  const province = countrySubdivision.find(
    c => c['@id'] === permit.entityCoordinate?.countrySubdivision
  );

  return (
    <>
      <Text>
        {permit.entityCoordinate?.address?.civicNumber ?? ''}
        {permit.entityCoordinate?.address?.unitNumber &&
          ` #${permit.entityCoordinate?.address?.unitNumber}`}
        , {permit.entityCoordinate?.address?.streetName ?? ''}
      </Text>
      <Text>{permit.entityCoordinate?.city ?? ''}</Text>
      <Text>
        {province && province.name}, {province && province.countryName}
      </Text>
      <Text>{permit.entityCoordinate?.postalCode?.toUpperCase() ?? ''}</Text>
    </>
  );
};

export default PermitAddressFormat;
